import _ from 'lodash';
import angular from 'angular';
import template from './dynamicCriteriaView.html';
import { DynamicCriteriaComponent } from '../dynamicCriteria/dynamicCriteriaComponent';

export class DynamicCriteriaComponentWithExcluded extends DynamicCriteriaComponent {
    getSubCriteriaData = async function () {
        if (this.data.subCriteria !== null) {
            return this.staticDataService.getStaticData(this.data.subCriteria.lookupData, (data) => {
                this.dynamicSubCriteriaData = data;
                this.addNewInitialAdditionalOptions = _.chain(data)
                    .filter(o => _.toNumber(o.id) > 0)
                    .sortBy((o) => {
                        const absValue = Math.abs(_.toNumber(o.id));

                        return _.indexOf([2, 1, 3], absValue);
                    })
                    .value();

                if (data) {
                    this.data.selected = (this.data.selected || []).map((item) => {
                        const additionalId = _.get(item, 'additional.uid');
                        const currentAdditionalValue = _.get(item, 'additional.value');
                        const additionalValue = data.find(({ id }) => id === additionalId);

                        if (additionalValue && !currentAdditionalValue) {
                            return {
                                ...item,
                                additional: {
                                    ...item.additional,
                                    ...additionalValue,
                                },
                            };
                        }

                        return item;
                    });
                }
            });
        }

        return Promise.resolve();
    };

    saveChanges(idx, value) {
        this.mandatoryPopUpView = -1;

        const newPriorityValue = value.required;
        if (newPriorityValue === 'excluded') {
            this.data.selected[idx].required = 'filter';
        } else {
            this.data.selected[idx].required = newPriorityValue;
        }

        const index = _.findIndex(this.mandatoryValues, { value: this.data.selected[idx].required });
        if (this.requiredIndexes.length === 0) {
            if (index >= 0) {
                const items = this.data.selected;
                for (let i = 0; i < items.length; i++) {
                    const importantIdx = _.findIndex(
                        this.mandatoryValues,
                        { value: this.data.selected[i].required },
                    );

                    this.requiredIndexes.push({
                        requiredValue: importantIdx,
                    });
                }

                this.requiredIndexes[idx].requiredValue = index;
            } else {
                this.requiredIndexes.push({
                    requiredValue: 0,
                });
            }
        } else if (index >= 0) {
            if (this.requiredIndexes[idx]) {
                this.requiredIndexes[idx].requiredValue = index;
            } else {
                this.requiredIndexes.push({
                    requiredValue: index,
                });
            }
        } else if (this.requiredIndexes[idx]) {
            this.requiredIndexes[idx].requiredValue = 0;
        } else {
            this.requiredIndexes.push({
                requiredValue: index,
            });
        }
        const subCriterita = _.find(this.dynamicSubCriteriaData, { id: value.additional.uid });
        if (subCriterita) {
            this.subCriteriaValue = subCriterita;
            this.data.selected[idx].additional = {
                uid: this.subCriteriaValue.id,
                value: this.subCriteriaValue.text,
            };
            delete this.data.selected[idx].status;
        }
    }


    setPopupCriteriaIndex(criteriaIndex) {
        this.mandatoryPopUpView = criteriaIndex;
    }

    closePopup() {
        this.mandatoryPopUpView = -1;
    }
}

export const config = {
    bindings: {
        data: '=',
        lastSearch: '=',
        allData: '=',
        disable: '=',
        createJob: '=',
        doNotHideDropDownAfterSelect: '=',
        onChange: '&',
        onBeforeValueAdded: '&',
    },
    controller: DynamicCriteriaComponentWithExcluded,
    template,
    controllerAs: 'ctrl',
};

angular
    .module('TALENYA-FE')
    .component('dynamicCriteriaWithExcludeOption', config);

